<template>
  <div class="search-form pt-4 lg:pt-8">
    <div class="content">
      <!-- If division is UKTSP, show UKTSP FAQs -->
      <help-browser
        v-if="
          $store.state.subdomain.company.division_code === 'tshirt_printing_uk'
        "
        faq-code="screenprint"
        contact-form-code="contact_uktsp"
      />
      <!-- Otherwise show normal customer FAQs -->
      <help-browser
        v-else-if="
          $store.state.subdomain.platform.id === 15 // platform is Teemill Trading
        "
        faq-code="customer"
        contact-form-code="contact_teemill_b2c"
      />
      <help-browser
        v-else
        faq-code="customer"
        contact-form-code="contact_default"
      />
    </div>
  </div>
</template>

<script>
import {HelpBrowser, ContactInformation} from '@teemill/modules/faq';
import {computed} from 'vue';
import {useHead} from '@vueuse/head';

export default {
  name: 'HelpPage',

  components: {
    HelpBrowser,
    ContactInformation,
  },

  created() {
    useHead(
      computed(() => ({
        title: this.$store.state.title,
      }))
    );
  },
};
</script>

<style lang="scss" scoped>
.content {
  min-height: 100vh;
  margin-bottom: 660px;
}

.search-form {
  background-color: var(--tml-page-background-color);
}
</style>
